import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, Row, Col, Button, Form, CustomInput, Label, FormGroup, Input } from 'reactstrap';
import { putAPI, deleteAPI } from '../../Base/API';
import { BlankCard } from '../../Base/Common/CommonUIComponents';
import { handleNotification } from '../../Base/Common/Notification';
import { FormattedMessage, injectIntl } from 'react-intl';
import ConfirmActionModal from '../../Base/Common/ConfirmActionModal';

class CancellationReasonModal extends Component {
    static displayName = CancellationReasonModal.name;

    constructor(props) {
        super(props);

        this.state = {
            block: false,
            error: [],
            reason: this.props.selectedReason || { active: true },
            confirmActionModal: false,
        };
    }

    saveReason = (e) => {
        e.preventDefault();
        this.setState({ block: true });

        const body = this.state.reason;

        putAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                else if (data.response && data.response.length > 0) {
                    handleNotification(data, <FormattedMessage id="CancellationReasons.ReasonSaved" />, <FormattedMessage id="generic.success" />);
                    this.props.updateTable(data.response[0], false);
                }
                this.setState({ block: false });
            }
            else this.setState({ block: false });
        }, '/api/Voucher/v1/Config/cancellationReasons', JSON.stringify({ request: body }));
    }

    removeReason = (e) => {
        e && e.preventDefault();
        this.setState({ block: true });

        deleteAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                else {
                    handleNotification(data, <FormattedMessage id="CancellationReasons.ReasonDeleted" />, <FormattedMessage id="generic.success" />);
                    this.props.updateTable(this.state.reason, true);
                }
                this.setState({ block: false });
            }
            else this.setState({ block: false });
        }, '/api/Voucher/v1/Config/cancellationReasons/' + this.state.reason.id);
    }

    handleChange = (evt) => {
        const { name, value } = evt.target;
        this.setState(prevState => ({
            reason: {
                ...prevState.reason,
                [name]: value,
            },
        }));
    }

    handleSwitch = (evt) => {
        const { id, checked } = evt.target;

        this.setState(prevState => ({
            reason: {
                ...prevState.reason,
                [id]: checked,
            },
        }));
    }

    render() {
        const { reason } = this.state;

        return (
            <>
            <Modal isOpen={this.props.modal} toggle={this.props.toggleModal} fade={false} className="modal-xl">
                <ModalHeader toggle={this.props.toggleModal}>
                    {reason.id ? <FormattedMessage id="CancellationReasons.EditReason" /> : <FormattedMessage id="CancellationReasons.CreateReason" />}
                </ModalHeader>
                <ModalBody className="modal-xl p-0">
                    <BlankCard block={this.state.block} error={this.state.error}>
                        <Form onSubmit={this.saveReason}>
                            <Row className="mb-3 align-items-center">
                                <Label sm={2}><FormattedMessage id="CancellationReasons.DisplayOrder" /></Label>
                                <Col sm={4}>
                                    <Input
                                        type="number"
                                        name="displayOrder"
                                        value={reason.displayOrder ?? ''}
                                        onChange={this.handleChange}
                                        min="0"
                                    />
                                </Col>
                                <Label sm={2}><FormattedMessage id="generic.status" /></Label>
                                <Col className="col-2">
                                    <CustomInput
                                        name="active"
                                        type="switch"
                                        id="active"
                                        checked={reason.active || false}
                                        onChange={this.handleSwitch}
                                    />
                                </Col>
                                <Col className="text-right">
                                    {reason.id ?
                                        <Button className="btn-sm btn-host mr-2" type="button" onClick={() => this.setState({ confirmActionModal: true })}>
                                            <i className="fa-solid fa-trash-can" />
                                        </Button>
                                        : ''}
                                    <Button className="btn-sm btn-host" type="submit">
                                        <i className="fa-solid fa-floppy-disk" />
                                    </Button>
                                </Col>
                            </Row>
                            <FormGroup row className="align-items-center">
                                <Label sm={2}><FormattedMessage id="generic.Name" /></Label>
                                <Col sm={10}>
                                    <Input
                                        type="text"
                                        name="name"
                                        value={reason.name || ''}
                                        onChange={this.handleChange}
                                        required
                                        maxLength="100"
                                    />
                                </Col>
                            </FormGroup>
                            
                        </Form>
                    </BlankCard>
                </ModalBody>
            </Modal>

            {this.state.confirmActionModal ?
                <ConfirmActionModal
                    modal={this.state.confirmActionModal}
                    toggleModal={() => this.setState({ confirmActionModal: false })}
                    actionFunction={this.removeReason}
                    text={<FormattedMessage id="CancellationReasons.DeleteConfirmation" />}
                    block={this.state.block}
                />
            : ''}
        </>
        );
    }
}

export default injectIntl(CancellationReasonModal);
